import type { ReactNode, RefObject } from 'react';
import { createRef } from 'react';

import { useIntersectionObserver } from './useIntersectionObserver';

/** Determines if the call-to-action should be shown. */
export const useCallToActionObserver = (
  targetRef: RefObject<HTMLElement> = createRef(),
  callToAction?: ReactNode
): boolean => {
  const observerEntry = useIntersectionObserver(targetRef, {
    rootMargin: `0px 0px -95% 0px`,
  });

  if (!observerEntry) {
    return false;
  }
  if (!callToAction) {
    return false;
  }
  if (!targetRef.current) {
    return false;
  }

  const showCallToAction =
    observerEntry.isIntersecting || observerEntry.boundingClientRect.bottom < 0;

  return showCallToAction;
};
